import GestockWebApp from './GestockWebApp/GestockWebApp';
import './Gestock.css';

export default function Gestock() {
  return (
    <div className="gestock-root">
      <GestockWebApp />
    </div>
  );
}
